var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTvBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69998 21.8996C9.89998 19.4996 14.1 19.4996 15.3 21.8996M5.93998 17.0996H18.06C19.4041 17.0996 20.0762 17.0996 20.5896 16.838C21.0411 16.6079 21.4083 16.2408 21.6384 15.7892C21.9 15.2758 21.9 14.6037 21.9 13.2596V5.93961C21.9 4.59548 21.9 3.92342 21.6384 3.41003C21.4083 2.95844 21.0411 2.59129 20.5896 2.36119C20.0762 2.09961 19.4041 2.09961 18.06 2.09961H5.93998C4.59585 2.09961 3.92379 2.09961 3.4104 2.36119C2.95881 2.59129 2.59166 2.95844 2.36156 3.41003C2.09998 3.92342 2.09998 4.59548 2.09998 5.93961V13.2596C2.09998 14.6037 2.09998 15.2758 2.36156 15.7892C2.59166 16.2408 2.95881 16.6079 3.4104 16.838C3.92379 17.0996 4.59585 17.0996 5.93998 17.0996Z",
    stroke: "#007BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvBlue);
export default __webpack_public_path__ + "static/media/tv-blue.609ff00cc8260531ea769da7c5ef9ab9.svg";
export { ForwardRef as ReactComponent };